(function MytripsCreateAccount($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		// Adzuki.onload('/MyTrips/createAccount/', function onload()
		// {
		// 	setTimeout(function timeout() {
		// 		$('#captcha').show();
		// 	}, 500);
		// });
	});
}(jQuery, window.Adzuki || {}));